export const openCoordsGoogleMaps = (lat, lon) => {
  const url = `https://www.google.com/maps?q=${lat},${lon}`;
  window.open(url, "_blank");
};
